import { IconButton,Stack,Tooltip,Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import br from "../../assets/images/brazil.png";
import es from "../../assets/images/spain.png";
import usa from "../../assets/images/usa.png";

export default function Translation() {
  const { t, i18n } = useTranslation('translation');
  const [hovered, setHovered] = useState('');

  const style = (value: string) => ({
    width: hovered === value ? '25px' : i18n.resolvedLanguage === value ? '20px' : '15px',
    height: hovered === value ? '25px' : i18n.resolvedLanguage === value ? '20px' : '15px',
    filter: hovered === value ? 'grayscale(0%)' : i18n.resolvedLanguage === value ? 'grayscale(0%)' : 'grayscale(100%)',
  });

  return (
    <Stack
      direction="row"
      spacing={0.5}
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {window.innerWidth >= 750 && <Typography variant='subtitle2'>{t('choose')}</Typography>}
      <Tooltip title={'PT-BR'}>
        <span>
          <IconButton
            disabled={i18n.resolvedLanguage === 'pt'}
            onClick={() => i18n.changeLanguage('pt')}>
            <img
              onMouseEnter={() => setHovered('pt')}
              onMouseLeave={() => setHovered('')}
              style={style('pt')}
              src={br}
              alt='brazilFlag' />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={'EN-US'}>
        <span>
          <IconButton
            disabled={i18n.resolvedLanguage === 'en'}
            onClick={() => i18n.changeLanguage('en')}>
            <img
              onMouseEnter={() => setHovered('en')}
              onMouseLeave={() => setHovered('')}
              style={style('en')}
              src={usa}
              alt='usaFlag' />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={'ES-ES'}>
        <span>
          <IconButton disabled={i18n.resolvedLanguage === 'es'} onClick={() => i18n.changeLanguage('es')}>
            <img
              onMouseEnter={() => setHovered('es')}
              onMouseLeave={() => setHovered('')}
              style={style('es')}
              src={es}
              alt='spainFlag' />
          </IconButton>
        </span>
      </Tooltip>
    </Stack >
  );
}
